module.exports = __webpack_public_path__ + "media/images/feature/ssc-2022-poster-2b0484f9c1a25f70437551f158dd9542.jpg";